/**
 * Created by xuqiang on 2018/3/13.
 */
import {request } from '../http';
import domain from '../domain';
var InteractService = function () {
    if (domain.env === 'online') {
        this.domain = "//interact.51tiangou.com";
    } else {
        this.domain = "//interact." + domain.env + ".66buy.com.cn";
    }
};
//刮刮乐通知发奖
InteractService.prototype.scratchticketDraw = function (params = {}) {
    let that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/publics/scratchticket/draw", params);
};

//刮刮乐查询是否已经发奖
InteractService.prototype.queryScratchticket = function (params = {}) {
    let that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/publics/scratchticket/checkDraw", params);
};


/**
 * 专柜 vr 预览场景信息
 * */
InteractService.prototype.panoramaPreview = function(params){
	return this._serviceAjaxCom('/pano/scene/preview', params);
};
/**
 * 专柜 vr 查看某个专柜的场景
 * */
InteractService.prototype.panoramaByCounterId = function(params){
    return this._serviceAjaxCom('/pano/scene/query', params);
};
/**
 * 专柜 vr 检查某个专柜是否配置了 vr 实景
 * */
InteractService.prototype.checkPanorama = function(params){
    return this._serviceAjaxCom('/pano/scene/check', params);
};

InteractService.prototype._serviceAjaxCom = function(url, params) {
    params.url = this.domain + url;
    return request(params);
};
export default new InteractService();